export const PAYOUT_ENTITY_REQUESTS = [
  { platform: "faphouse", entity_type: "faphouse_payout" },
  { platform: "justforfans", entity_type: "jff_payout_observation" },
  { platform: "onlyfans_vip", entity_type: "onlyfans_message_performance" },
  { platform: "onlyfans_free", entity_type: "onlyfans_message_performance" },
];

export function isImportedPayout(entry) {
  const platform = String(entry.platform || "").toLowerCase();
  return ["justforfans", "onlyfans", "onlyfans_vip", "onlyfans_free"].includes(platform)
    && entry.source === "import" && /payout|invoice#/i.test(String(entry.notes || ""));
}

export function payoutRowsFromEntities(entityGroups) {
  return PAYOUT_ENTITY_REQUESTS.flatMap(({ platform, entity_type }) => (
    (entityGroups[`${platform}:${entity_type}`] || []).filter((entity) => (
      entity.platform === platform && entity.entity_type === entity_type
    ))
  ).flatMap((entity) => {
    const data = entity.normalized_payload || entity.normalized || {};
    const base = {
      id: `entity:${entity.platform}:${entity.account_id}:${entity.external_id}`,
      attachmentKey: `entity:${entity.platform}:${entity.account_id}:${entity.external_id}`,
      platform,
      accountId: entity.account_id,
      date: entity.captured_at || "",
      source: "Extension",
      status: "Status unavailable",
      notes: "",
      amount: null,
      currency: null,
      kind: "",
    };

    if (entity_type === "faphouse_payout") return [{
      ...base,
      date: data.payout_date || base.date,
      amount: data.payout_amount_value ?? entity.price,
      currency: data.currency || entity.currency,
      status: data.payout_status || entity.status || base.status,
      kind: "Extension payout",
      notes: data.payout_method ? `Method: ${data.payout_method}` : "",
    }];

    if (entity_type === "jff_payout_observation") return [{
      ...base,
      date: data.date_submitted || base.date,
      amount: data.reported_amount,
      currency: data.currency,
      status: data.status || base.status,
      kind: "Extension payout",
      notes: data.expected_arrival ? `Expected ${data.expected_arrival}` : "",
    }];

    return [{
      ...base,
      date: data.date_sent || base.date,
      amount: data.total_earned,
      currency: data.currency,
      status: "Message earnings",
      kind: "Paid-message performance",
      notes: `${data.purchased ?? "—"} purchased / ${data.sent_to ?? "—"} sent${data.conversion_rate_pct == null ? "" : ` · ${data.conversion_rate_pct}% conversion`}`,
    }];
  }));
}

export function findPayoutInvoice(documents, row) {
  const exactTag = `payout-record:${row.attachmentKey}`;
  const receipts = Array.isArray(documents) ? documents : [];
  return receipts.find((document) => (
    (row.legalRevenueId && document.linked_revenue_id === row.legalRevenueId)
    || (document.tags || []).includes(exactTag)
  ));
}

export async function uploadPayoutInvoice(api, row, file) {
  if (!file) return null;
  if (file.size > 50 * 1024 * 1024) throw new Error("Invoice must be under 50 MB");
  const isPdf = file.type === "application/pdf" || /\.pdf$/i.test(file.name);
  if (!isPdf && !file.type.startsWith("image/")) throw new Error("Upload a PDF or image invoice");

  const formData = new FormData();
  formData.append("file", file);
  formData.append("folder", "legal/receipt");
  formData.append("resource_type", isPdf ? "raw" : "auto");
  const upload = await api.post("/api/cloudinary/upload", formData);
  const platform = row.platformLabel || row.platform;
  const response = await api.post("/api/legal/", {
    title: `${platform} ${row.kind} · ${row.date || "Undated"}`,
    doc_type: "receipt",
    counterparty: platform,
    amount: row.amount == null ? null : Number(row.amount),
    currency: row.currency || "EUR",
    issued_date: /^\d{4}-\d{2}-\d{2}$/.test(row.date) ? row.date : null,
    file_url: upload.data.secure_url,
    tags: ["accounting", "payout", `platform:${row.platform}`, `payout-record:${row.attachmentKey}`],
    notes: `Source: ${row.source}${row.reference ? ` · Reference: ${row.reference}` : ""}${row.notes ? ` · ${row.notes}` : ""}`,
    ...(row.legalRevenueId ? { linked_revenue_id: row.legalRevenueId } : {}),
  });
  return response.data;
}